module.exports = __webpack_public_path__ + "static/media/main2.098546d4.jpg";